import { isLifeCheckStale } from '../notifications/life-check-prompt';

export const WEB_ONBOARDING_COMPLETED_STORAGE_KEY = 'adulting_onboarded';
const NATIVE_ONBOARDING_COMPLETED_PREFIX = 'adulting_onboarding_completed';

export type OnboardingPromptMode = 'ignition' | 'resurface';

type ResolveOnboardingProgressInput = {
  completionFlagLoaded: boolean;
  completionFlag: boolean;
  workType?: string | null;
  entrySurface: 'direct' | 'prompt';
  promptActive?: boolean;
};

export function buildNativeOnboardingCompletedKey(userId: string) {
  return `${NATIVE_ONBOARDING_COMPLETED_PREFIX}:${userId}`;
}

export function hasCompletedOnboardingCoreSetup(workType: string | null | undefined) {
  return typeof workType === 'string' && workType.trim().length > 0;
}

export function resolveOnboardingProgress({
  completionFlagLoaded,
  completionFlag,
  workType,
  entrySurface,
  promptActive = false,
}: ResolveOnboardingProgressInput) {
  const hasCoreSetup = hasCompletedOnboardingCoreSetup(workType);
  const isComplete = completionFlag || hasCoreSetup;
  const entryActive = entrySurface === 'direct' ? true : promptActive;

  return {
    completionFlagLoaded,
    hasCoreSetup,
    isComplete,
    shouldWaitForCompletionFlag: entryActive && !completionFlagLoaded,
    shouldShowSetup: entryActive && completionFlagLoaded && !isComplete,
  };
}

export function resolveLifeCheckPromptMode({
  latestLifeCheckCreatedAt,
  ignitionPromptDismissed,
  resurfacePromptDismissed,
}: {
  latestLifeCheckCreatedAt?: string | null;
  ignitionPromptDismissed: boolean;
  resurfacePromptDismissed: boolean;
}): OnboardingPromptMode | null {
  if (!latestLifeCheckCreatedAt) {
    return ignitionPromptDismissed ? null : 'ignition';
  }

  return isLifeCheckStale(latestLifeCheckCreatedAt) && !resurfacePromptDismissed
    ? 'resurface'
    : null;
}
